import { render, staticRenderFns } from "./ProductCodesTransfer.vue?vue&type=template&id=01ed754f&scoped=true&"
import script from "./ProductCodesTransfer.vue?vue&type=script&lang=js&"
export * from "./ProductCodesTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ProductCodesTransfer.vue?vue&type=style&index=0&id=01ed754f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ed754f",
  null
  
)

export default component.exports